export default class AlertHandler {
    static showAlert(message, type) {
        const alertContainer = document.getElementById('alert-container');
        alertContainer.innerHTML = `<div class="alert alert-${type} mb-0 mt-3" role="alert">${message}</div>`;
        setTimeout(() => {
            alertContainer.innerHTML = '';
        }, 2000);
    }
}